import React, { useEffect, useMemo, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import DataTable from "react-data-table-component";
import FilterComponent from "../../../config/FilterComponent";
import { apiHelper } from "../../../redux/apiHelper";
import Columns from "./Columns";
import Loader from "../../../config/Loader";

const UserCourses = () => {
  const [paymentData, setPaymentData] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const userId = JSON.parse(localStorage.getItem("userId"));

  const filteredItems = paymentData?.filter(
    (item) =>
      (item.description &&
        item.description.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.type &&
        item.type.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.status &&
        item.status.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.amount &&
        item.amount.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.createdAt &&
        item.createdAt.toLowerCase().includes(filterText.toLowerCase()))
  );

  const fetchPaymentListing = async () => {
    try {
      const res = await apiHelper("get", `/payments?userId=${userId}`, "");
      if (res?.data) {
        const { data } = res;
        setPaymentData(data?.payments);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchPaymentListing().finally(() => setIsLoading(false));
  }, [userId]);

  useEffect(() => {
  }, [paymentData]);

  const columns = useMemo(() => Columns(), []);

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <>
      <Sidebar />
      <div className="dashboard-wraper">
        {isLoading ? (
          <Loader />
        ) : (
          <div className="states-days common-listing">
            <div className="dashboard-states">
              <div className="states-header">
                <h1 className="text-dark pr-6 pb-2 text-5xl sm:text-5xl">قائمة المدفوعات</h1>
              </div>
              <div className="dashboard-states-content">
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  pagination
                  paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  persistTableHead
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UserCourses;
